const downArrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
downArrow.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
downArrow.setAttribute('viewBox', '0 0 384 512');
downArrow.setAttribute('class', 'w-8 h-8 fill-secondary-100');

const downArrowPath = document.createElementNS(
	'http://www.w3.org/2000/svg',
	'path',
);
downArrowPath.setAttribute(
	'd',
	'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z',
);

downArrow.appendChild(downArrowPath);

const rightArrow = document.createElementNS(
	'http://www.w3.org/2000/svg',
	'svg',
);
rightArrow.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
rightArrow.setAttribute('viewBox', '0 0 448 512');
rightArrow.setAttribute('class', 'w-8 h-8');
rightArrow.setAttribute('fill', '#B47692');

const rightArrowPath = document.createElementNS(
	'http://www.w3.org/2000/svg',
	'path',
);
rightArrowPath.setAttribute(
	'd',
	'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z',
);

rightArrow.appendChild(rightArrowPath);

const todoItem = document.querySelectorAll("[data-controller='todo-item']");
const allTitles = document.querySelectorAll('h1,h2');

todoItem.forEach((el) => {
	const linkTo = el.querySelector("[data-todo-target='link']");
	if (linkTo) return;
	const footer = el.querySelector("[data-todo-target='footer']");
	const currTitle = el.querySelector(
		'[data-todo-target="todo-title"]',
	).innerText;
	let currId;
	for (const title of allTitles) {
		if (currTitle === title.innerText) {
			currId = title.closest('section')?.id;
			break;
		}
	}
	if (currId) {
		const currLink = document.createElement('a');
		currLink.href = `#${currId}`;
		currLink.appendChild(downArrow.cloneNode(true));
		footer.appendChild(currLink);
	}
});
